import { render, staticRenderFns } from "./DevBpbjStandardInfoModal.vue?vue&type=template&id=2f055511&scoped=true&"
import script from "./DevBpbjStandardInfoModal.vue?vue&type=script&lang=js&"
export * from "./DevBpbjStandardInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f055511",
  null
  
)

export default component.exports